import { render } from "./TechniciansGroupsView.vue?vue&type=template&id=7a908631"
import script from "./TechniciansGroupsView.vue?vue&type=script&lang=js"
export * from "./TechniciansGroupsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__